import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { StoreMenuCategoryRequestSchema } from '~/services/api/generated'
import { menuCategoryFieldsNormalizer } from '~/services/api/contracts/normalizers/menuCategoryFieldsNormalizer'

const schema = StoreMenuCategoryRequestSchema.strict()

export const MenuCategoryStore = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(menuCategoryFieldsNormalizer, schema)
